<template>
    <div v-if="loaded">
        <rkm-form ref="Form">
            <rkm-tabs>
                <rkm-tab
                    active
                    title="Acolhimento ACS/TACS"
                >
                    <BoxMotivoAtendimento :data="{ form, model: model.acolhimentoAcsTacs }" />

                    <BoxAntropometria
                        v-if="additionals.isTacs"
                        :data="{ form: form.acolhimentoAcsTacs, model: model.acolhimentoAcsTacs }"
                        :hidden-fields="['comprimentoPeDireito']"
                        @alturaChange="handleAlturaChange"
                        @circunferenciaAbdominalChange="handleCircunferenciaAbdominalChange"
                        @perimetroCefalicoChange="handlePerimetroCefalicoChange"
                        @perimetroPanturrilhaChange="handlePerimetroPanturrilhaChange"
                        @pesoChange="handlePesoChange"
                    />

                    <BoxSinaiVital
                        v-if="additionals.isTacs"
                        :data="{ form: form.acolhimentoAcsTacs, model: model.acolhimentoAcsTacs }"
                        @pressaoArterialChange="handlePressaoArterialChange"
                        @temperaturaChange="handleTemperaturaChange"
                    />

                    <BoxGlicemiaCapilar
                        v-if="additionals.isTacs"
                        :data="{ form: form.acolhimentoAcsTacs, model: model.acolhimentoAcsTacs }"
                        @glicemiaCapilarChange="handleGlicemiaCapilarChange"
                    />

                    <BoxMarcadoresConsumoAlimentar
                        v-if="additionals.showMarcadorConsumoAlimentar"
                        :data="{ form: form.acolhimentoAcsTacs, model: model.acolhimentoAcsTacs }"
                        closed
                    />

                    <BoxTria
                        v-if="additionals.showTria"
                        :data="{ form: form.acolhimentoAcsTacs, model: model.acolhimentoAcsTacs }"
                        closed
                    />

                    <rkm-row class="mt-2">
                        <rkm-col cols="auto">
                            <rkm-form-radio-group
                                label="Vacinação em dia"
                                v-model="model.acolhimentoAcsTacs.vacinacaoEmDia"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                                <rkm-form-radio :value="null">Não informado</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="auto">
                            <rkm-form-radio-group
                                label="Paciente com necessidades especiais"
                                v-model="model.acolhimentoAcsTacs.pacienteComNecessidadeEspecial"
                            >
                                <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                <rkm-form-radio :value="false">Não</rkm-form-radio>
                                <rkm-form-radio :value="null">Não informado</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="additionals.isTacs">
                        <rkm-col cols="auto">
                            <rkm-form-checkbox v-model="model.acolhimentoAcsTacs.orientacaoIndividualEmSaude">
                                Orientação individual em saúde
                            </rkm-form-checkbox>
                        </rkm-col>
                    </rkm-row>

                    <BoxProcedimento
                        v-if="additionals.isTacs"
                        :data="{ form, model: model.acolhimentoAcsTacs }"
                    />

                    <rkm-row :class="{ 'mt-2': additionals.isTacs }">
                        <rkm-col>
                            <rkm-form-radio-group
                                :options="form.acolhimentoAcsTacs.demandaTipos"
                                disabled
                                label="Tipo de demanda"
                                v-model="model.acolhimentoAcsTacs.demandaTipo"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="!!model.acolhimentoAcsTacs.demandaTipo">
                        <rkm-col cols="12">
                            <rkm-form-radio-group
                                :options="atendimentoTipos"
                                :validations="validations.atendimentoTipo"
                                label="Tipo de atendimento"
                                text-field="nome"
                                v-model="model.acolhimentoAcsTacs.atendimentoTipoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <template v-if="additionals.criaFichaAtencaoBasica">
                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-form-select
                                    :options="form.acolhimentoAcsTacs.equipes"
                                    :validations="validations.equipe"
                                    label="Equipe"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.acolhimentoAcsTacs.equipeId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="form.acolhimentoAcsTacs.turnos"
                                    :validations="validations.turno"
                                    label="Turno"
                                    text-field="nome"
                                    v-model="model.acolhimentoAcsTacs.turnoId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="form.acolhimentoAcsTacs.locaisAtendimento"
                                    :validations="validations.atencaoBasicaLocalAtendimento"
                                    label="Local de atendimento"
                                    text-field="descricao"
                                    v-model="model.acolhimentoAcsTacs.atencaoBasicaLocalAtendimentoId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <BoxDesfecho
                        :data="{ additionals, form: form.acolhimentoAcsTacs, model: model.acolhimentoAcsTacs }"
                        :fila-id="filaId"
                    />
                </rkm-tab>

                <rkm-tab
                    v-if="verificarPermissao('show-ambulatorio-historico-atendimento')"
                    title="Histórico"
                >
                    <BoxHistorico
                        :data="{
                            form: {
                                historico: this.form.historico,
                                paciente: { prontuario: this.form.paciente.prontuario }
                            }
                        }"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>

        <rkm-fab-area>
            <rkm-fab>
                <rkm-fab-item
                    @click="$refs.ModalMedicao.open()"
                    icon="search"
                    label="Medições"
                />

                <rkm-fab-item
                    @click="printCarteiraVacinacao"
                    icon="search"
                    label="Visualizar carteirinha de vacinação"
                />
            </rkm-fab>
        </rkm-fab-area>

        <ModalMedicao
            :data="{
                additionals: {
                    ...additionals,
                    paciente: form.paciente,
                },
                form: form.medicoes,
                model: model.medicoes,
            }"
            ref="ModalMedicao"
            readonly
        />

        <ModalImpressao
            @closed="closedModalImpressao"
            ref="ModalImpressao"
        />
    </div>
</template>

<script>
// Components.
import BoxMotivoAtendimento from './components/motivo-atendimento/Form'
import BoxAntropometria from '@/components/ambulatorio/components/antropometria/Index'
import BoxSinaiVital from '@/components/ambulatorio/components/sinal-vital/Index'
import BoxGlicemiaCapilar from '@/components/ambulatorio/components/glicemia-capilar/Index'
import BoxMarcadoresConsumoAlimentar from './components/marcador-consumo-alimentar/Index'
import BoxTria from './components/tria/Index'
import BoxProcedimento from './components/procedimento/Index'
import BoxDesfecho from './components/desfecho/Form'
import BoxHistorico from '@/components/ambulatorio/atendimento/components/historico/Index'
import ModalMedicao from '@/components/ambulatorio/atendimento/components/medicao/Modal'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'

// Mixins.
import { repository, error, stringCase, object, permissao, file, unmask } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Enums.
import procedimento from '@/enums/sigtap/procedimento'
import demandaTipo from '@/enums/ambulatorio/demandaTipo'

export default {
    components: {
        BoxMotivoAtendimento,
        BoxAntropometria,
        BoxSinaiVital,
        BoxGlicemiaCapilar,
        BoxMarcadoresConsumoAlimentar,
        BoxTria,
        BoxProcedimento,
        BoxHistorico,
        BoxDesfecho,
        ModalMedicao,
        ModalImpressao,
    },
    computed: {
        atendimentoTipos() {
            if (!this.model.acolhimentoAcsTacs.demandaTipo) {
                return []
            }

            if (this.model.acolhimentoAcsTacs.demandaTipo === this.enums.demandaTipo.ESPONTANEA) {
                return this.form.acolhimentoAcsTacs.atendimentoTipos.filter(t => t.isDemandaEspontanea)
            }

            return this.form.acolhimentoAcsTacs.atendimentoTipos.filter(t => !t.isDemandaEspontanea)
        },
        validations() {
            return {
                atendimentoTipo: { required: true },
                equipe: { required: true },
                turno: { required: !!this.model.acolhimentoAcsTacs.equipeId },
                atencaoBasicaLocalAtendimento: { required: !!this.model.acolhimentoAcsTacs.equipeId },
            }
        },
    },
    created() {
        this.repositories = {
            acolhimentoAcsTacs: this.getConectaSusRepository('ambulatorio.acolhimentoAcsTacs'),
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio'),
            impressaoImunizacao: this.getConectaSusRepository('impressao.imunizacao'),
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        form: null,
        model: null,
        loaded: false,
        enums: { procedimento, demandaTipo },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.acolhimentoAcsTacs.create(this.filaId)
                .then(({ data }) => {
                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.$emit('load', {
                        additionals: this.additionals,
                        form: this.form,
                        model: this.model,
                    })

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.Form.validate().then(valid => {
                if (!valid) return

                this.setLoading()

                this.repositories.acolhimentoAcsTacs.store(this.prepareData())
                    .then(({ data }) => {
                        this.openModalImpressao(data.atendimentoId)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
        prepareData() {
            const request = {
                filaId: this.filaId,
                paciente: {
                    telefonePrincipal: {
                        id: this.form.paciente.telefoneId,
                        numero: this.form.paciente.telefoneNumero ? this.unMaskPhone(this.form.paciente.telefoneNumero) : null,
                        autorizaSms: this.form.paciente.telefoneAutorizaSms,
                        atualizado: this.form.paciente.telefoneAtualizado,
                    },
                },
                ciapId: this.model.acolhimentoAcsTacs.ciap ? this.model.acolhimentoAcsTacs.ciap.id : null,
                motivoAtendimento: this.model.acolhimentoAcsTacs.motivoAtendimento,
                antropometria: {
                    altura: this.model.acolhimentoAcsTacs.antropometria.altura,
                    circunferenciaAbdominal: this.model.acolhimentoAcsTacs.antropometria.circunferenciaAbdominal,
                    perimetroCefalico: this.model.acolhimentoAcsTacs.antropometria.perimetroCefalico,
                    perimetroPanturrilha: this.model.acolhimentoAcsTacs.antropometria.perimetroPanturrilha,
                    peso: this.model.acolhimentoAcsTacs.antropometria.peso,
                },
                sinalVital: {
                    frequenciaCardiaca: this.model.acolhimentoAcsTacs.sinalVital.frequenciaCardiaca,
                    frequenciaRespiratoria: this.model.acolhimentoAcsTacs.sinalVital.frequenciaRespiratoria,
                    pressaoArterial: this.model.acolhimentoAcsTacs.sinalVital.pressaoArterial,
                    saturacaoO2: this.model.acolhimentoAcsTacs.sinalVital.saturacaoO2,
                    temperatura: this.model.acolhimentoAcsTacs.sinalVital.temperatura,
                },
                glicemiaCapilar: {
                    valor: this.model.acolhimentoAcsTacs.glicemiaCapilar.valor,
                    momentoColetaId: this.model.acolhimentoAcsTacs.glicemiaCapilar.momentoColetaId,
                },
                marcadorConsumoAlimentar: this.model.acolhimentoAcsTacs.marcadorConsumoAlimentar,
                tria: {
                    alimentosAcabaram: this.model.acolhimentoAcsTacs.tria.alimentosAcabaram,
                    comeuAlgunsAlimentos: this.model.acolhimentoAcsTacs.tria.comeuAlgunsAlimentos,
                },
                vacinacaoEmDia: this.model.acolhimentoAcsTacs.vacinacaoEmDia,
                pacienteComNecessidadeEspecial: this.model.acolhimentoAcsTacs.pacienteComNecessidadeEspecial,
                orientacaoIndividualEmSaude: this.model.acolhimentoAcsTacs.orientacaoIndividualEmSaude,
                procedimentos: this.model.acolhimentoAcsTacs.procedimentos.map(procedimento => {
                    return {
                        procedimentoId: procedimento.id,
                        cidId: procedimento.cidId,
                        automatico: procedimento.automatico,
                        quantidade: procedimento.quantidade,
                        localCurativo: procedimento.localCurativo,
                        materiais: procedimento.materiais
                            ? procedimento.materiais.map(m => ({
                                materialId: m.id,
                                materialQuantidade: m.quantidade,
                                materialEscolheuEntradaItemManualmente: m.materialEscolheuEntradaItemManualmente,
                                materialEntradaItens: m.materialEntradaItens
                                    ? m.materialEntradaItens.filter(i => i.quantidadeSaida > 0)
                                    : [],
                            }))
                            : [],
                    }
                }),
                atendimentoTipoId: this.model.acolhimentoAcsTacs.atendimentoTipoId,
                equipeId: this.model.acolhimentoAcsTacs.equipeId,
                turnoId: this.model.acolhimentoAcsTacs.turnoId,
                atencaoBasicaLocalAtendimentoId: this.model.acolhimentoAcsTacs.atencaoBasicaLocalAtendimentoId,
                desfecho: {
                    finalizado: this.model.acolhimentoAcsTacs.desfecho.finalizado === 'encaminhar'
                        ? false
                        : this.model.acolhimentoAcsTacs.desfecho.finalizado,
                    servicos: this.model.acolhimentoAcsTacs.desfecho.servicos,
                    prioridadeId: this.model.acolhimentoAcsTacs.desfecho.prioridadeId,
                    centroCustoEncaminhamentoId: this.model.acolhimentoAcsTacs.desfecho.centroCustoEncaminhamentoId,
                    posConsulta: this.model.acolhimentoAcsTacs.desfecho.posConsulta,
                },
                tempoAtendimento: this.tempoAtendimento,
            }

            if (this.additionals.isDemandaEspontanea) {
                request.desfecho.ocupacaoId = this.model.acolhimentoAcsTacs.desfecho.ocupacaoId
                request.desfecho.especialidadeId = this.model.acolhimentoAcsTacs.desfecho.especialidadeId
                request.desfecho.usuarioId = this.model.acolhimentoAcsTacs.desfecho.usuarioId
            }

            return this.camelObjectKeysToSnakeRecursive(request)
        },
        openModalImpressao(atendimentoId) {
            this.$refs.ModalImpressao.open('acolhimento-acs-tacs', atendimentoId)
        },
        closedModalImpressao() {
            this.showSaveNotification()
            this.$emit('save')
        },
        handlePesoChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!this.hasProcedimentoPeso()) {
                    this.insertProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)
                }
            } else {
                const antropometria = this.model.acolhimentoAcsTacs.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!antropometria.peso) {
                    this.deleteProcedimento(this.enums.procedimento.MEDICAO_DE_PESO)
                }
            }
        },
        handleAlturaChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!this.hasProcedimentoAltura()) {
                    this.insertProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)
                }
            } else {
                const antropometria = this.model.acolhimentoAcsTacs.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }

                if (!antropometria.altura) {
                    this.deleteProcedimento(this.enums.procedimento.MEDICAO_DE_ALTURA)
                }
            }
        },
        handlePerimetroCefalicoChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {
                const antropometria = this.model.acolhimentoAcsTacs.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            }
        },
        handleCircunferenciaAbdominalChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {
                const antropometria = this.model.acolhimentoAcsTacs.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            }
        },
        handlePerimetroPanturrilhaChange(value) {
            if (value) {
                if (!this.hasProcedimentoAntropometria()) {
                    this.insertProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            } else {
                const antropometria = this.model.acolhimentoAcsTacs.antropometria

                if (!antropometria.peso && !antropometria.altura && !antropometria.perimetroCefalico && !antropometria.circunferenciaAbdominal && !antropometria.perimetroPanturrilha) {
                    this.deleteProcedimento(this.enums.procedimento.AVALIACAO_ANTROPOMETRICA)
                }
            }
        },
        handlePressaoArterialChange(value) {
            if (value) {
                if (!this.hasProcedimentoPressaoArterial()) {
                    this.insertProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
                }
            } else {
                this.deleteProcedimento(this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)
            }
        },
        handleTemperaturaChange(value) {
            if (value) {
                if (!this.hasProcedimentoTemperatura()) {
                    this.insertProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
                }
            } else {
                this.deleteProcedimento(this.enums.procedimento.AFERICAO_DE_TEMPERATURA)
            }
        },
        handleGlicemiaCapilarChange(value) {
            if (value) {
                if (!this.hasProcedimentoGlicemiaCapilar()) {
                    this.insertProcedimento(this.enums.procedimento.GLICEMIA_CAPILAR)
                }
            } else {
                this.deleteProcedimento(this.enums.procedimento.GLICEMIA_CAPILAR)
            }
        },
        hasProcedimentoAntropometria() {
            return this.model.acolhimentoAcsTacs.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.AVALIACAO_ANTROPOMETRICA).length > 0
        },
        hasProcedimentoPeso() {
            return this.model.acolhimentoAcsTacs.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.MEDICAO_DE_PESO).length > 0
        },
        hasProcedimentoAltura() {
            return this.model.acolhimentoAcsTacs.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.MEDICAO_DE_ALTURA).length > 0
        },
        hasProcedimentoPressaoArterial() {
            return this.model.acolhimentoAcsTacs.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL).length > 0
        },
        hasProcedimentoTemperatura() {
            return this.model.acolhimentoAcsTacs.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.AFERICAO_DE_TEMPERATURA).length > 0
        },
        hasProcedimentoGlicemiaCapilar() {
            return this.model.acolhimentoAcsTacs.procedimentos.filter(procedimento => procedimento.codigo === this.enums.procedimento.GLICEMIA_CAPILAR).length > 0
        },
        insertProcedimento(codigo) {
            this.setLoading()

            this.repositories.procedimento.index({codigo})
                .then(response => {
                    const procedimento = response.data[0]

                    this.model.acolhimentoAcsTacs.procedimentos.push({
                        id: procedimento.id,
                        codigo: procedimento.codigo,
                        nome: procedimento.nome,
                        hasInstrumentoRegistroRaas: !!procedimento.hasInstrumentoRegistroRaas,
                        automatico: true,
                        quantidade: 1,
                        localCurativo: null,
                        materiais: [],
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        deleteProcedimento(codigo) {
            const index = this.model.acolhimentoAcsTacs.procedimentos.findIndex(procedimento => procedimento.codigo === codigo)

            if (index !== -1) {
                this.model.acolhimentoAcsTacs.procedimentos.splice(index, 1)
            }
        },
        printCarteiraVacinacao() {
            this.setLoading()

            this.repositories.impressaoImunizacao.carteiraVacinacao(this.form.paciente.id)
                .then(response => this.openFile(response.data, response.headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error, stringCase, object, permissao, file, unmask],
    props: {
        filaId: { type: Number, required: true },
        tempoAtendimento: { type: String, default: '00:00:00' },
    }
}
</script>